import axios from "axios";
import { triggerSessionAlert } from "../utils/SessionAlertHelper";

// Base URL for your API
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAllPromoCode = async ({ pagination, searchTerm }) => {
  try {
    const { page = 1, limit = 10 } = pagination || {};
    const search = searchTerm || "";
    const response = await axios.get(
      `${API_BASE_URL}/referral/?page=${page}&limit=${limit}&search=${search}`,
      { withCredentials: true }
    );
    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.referrals,
      totalPages: response.data.data.totalPages,
      currentPage: response.data.data.currentPage,
      totalCount: response.data.data.totalReferrals,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching banners.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};
export const generatePromoCode = async () => {
  try {
    const response = await axios.get(
      `
  ${API_BASE_URL}/referral/generate`,
      {
        withCredentials: true,
      }
    );
    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.referralCode,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching banners.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};
export const addPromoCode = async (formData) => {
  try {
    const response = await axios.post(
      `
  ${API_BASE_URL}/referral/create`,
      formData,
      {
        withCredentials: true,
      }
    );
    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching banners.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};
export const editPromoCode = async (formData) => {
  try {
    const response = await axios.put(
      `
  ${API_BASE_URL}/referral/edit`,
      formData,
      {
        withCredentials: true,
      }
    );
    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching banners.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const validatePromoCode = async (referralCode) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/referral/validate/${encodeURIComponent(referralCode)}`,
      {
        withCredentials: true,
      }
    );
    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while validating the referral code.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};
